var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentStatusComponent,{tag:"component",on:{"redirect-to-merchant":_vm.redirectToMerchantSite}})
}
var staticRenderFns = []

export { render, staticRenderFns }